/**
 * Time utility functions for managing tomorrow list visibility and promotion
 */

// Default promotion cutoff time: 6:00 PM (18:00)
const DEFAULT_CUTOFF_HOUR = 18;

/**
 * Check if the current local time is after the promotion cutoff time
 * @param {number} [cutoffHour=18] - The cutoff hour (0-23)
 * @returns {boolean} True if current time is after the cutoff time
 */
export function isAfterPromotionCutoff(cutoffHour = DEFAULT_CUTOFF_HOUR) {
  const now = new Date();
  const hour = now.getHours();

  return hour >= cutoffHour;
}

/**
 * Check if a list should be visible based on its type and current time
 * @param {string} listType - The type of the list
 * @param {number} [cutoffHour=18] - The cutoff hour (0-23)
 * @returns {boolean} True if the list should be visible
 */
export function shouldShowList(listType, cutoffHour = DEFAULT_CUTOFF_HOUR) {
  // Tomorrow list is only visible after the cutoff time
  if (listType === 'tomorrow') {
    return isAfterPromotionCutoff(cutoffHour);
  }
  // All other lists are always visible
  return true;
}

/**
 * Get the target list type for promotion based on current time
 * @param {number} [cutoffHour=18] - The cutoff hour (0-23)
 * @returns {string} 'tomorrow' if after cutoff, 'main' otherwise
 */
export function getPromotionTargetListType(cutoffHour = DEFAULT_CUTOFF_HOUR) {
  return isAfterPromotionCutoff(cutoffHour) ? 'tomorrow' : 'main';
}
